var publicScrolledIndex = 0;

export default function initializeCarousel() {
    var carouselWrapper = document.getElementById('carouselwrapper');
    var images = document.querySelectorAll('img.carouselimage');    

    if (!carouselWrapper) {
        return
    }

    var imagesLength = images.length;

    var leftArrow = document.querySelectorAll('div.carouselblock div.arrow#left');    
    var rightArrow = document.querySelectorAll('div.carouselblock div.arrow#right');    

    leftArrow[0].addEventListener("click", function () { 
        scrollTo(imagesLength, publicScrolledIndex, 1, false)
    })

    rightArrow[0].addEventListener("click", function () {
        scrollTo(imagesLength, publicScrolledIndex, 1, true);
    })

    window.onresize = function (event) {
        carouselWrapper.style.transitionDuration = "0.5s";

        setTimeout(function () {
            carouselWrapper.style.transitionDuration = "1.5s";
        }, 500);

        scrollTo(imagesLength, publicScrolledIndex, 0, true)
    };
}

/// scrollTo() requires a length, index, a value to add or subtract and a true or false to add or subtract.
function scrollTo(imagesLength, scrolledIndex, subtractOrAddVal, add) {
    var carouselWrapper = document.getElementById('carouselwrapper');
    var images = document.querySelectorAll('img.carouselimage');   

    if (scrolledIndex >= 0 && scrolledIndex <= imagesLength) {
        var imageWidth = images[0].offsetWidth;
        var translateX = 0;

        // imageWidth * imagesLength is the max length. But since its already an imageWidth wide,
        // we're subtracting that.
        var maxLength = (imageWidth * imagesLength) - imageWidth;

        if (add == true) {
            if (scrolledIndex >= imagesLength) {
                translateX = maxLength;
                publicScrolledIndex = imagesLength - 1;
            } else {
                if (imageWidth * (scrolledIndex + subtractOrAddVal) >= maxLength) {
                    translateX = maxLength;
                    publicScrolledIndex = imagesLength - 1;
                } else {
                    translateX = imageWidth * (scrolledIndex + subtractOrAddVal);
                    publicScrolledIndex = scrolledIndex + subtractOrAddVal;
                }
            }
        } else {
            if (scrolledIndex <= 0) {
                translateX = imageWidth * 0;
                publicScrolledIndex = 0;
            } else {
                translateX = imageWidth * (scrolledIndex - subtractOrAddVal);
                publicScrolledIndex = scrolledIndex - subtractOrAddVal;
            }
        }
        carouselWrapper.style.transform = "translateX(-" + translateX + "px)";
    }
}